import { Button, Checkbox, Col, Layout, Row, Space, Spin, Typography, message } from "antd";
import Cookies from "js-cookie";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import InfoGreyIcon from "../../../assets/icons/info-grey.svg";
import NewArrowLeftIcon from "../../../assets/icons/new-arrow-left.svg";
import LockIcon from "../../../assets/icons/payment-lock.svg";
import InfoPaymentImg from "../../../assets/images/info-payment.webp";
import TheApplePayButton from "../../../components/ApplePayButton/TheApplePayButton";
import AuthButtonComponent from "../../../components/AuthButtonCompnent";
import CountryDropdownComponent from "../../../components/CountryDropdownComponent/CountryDropdownComponent";
import FanPaymentPopUp from "../../../components/FanPaymentPopUp";
import FreeSubscriptionPaymentInfoModal from "../../../components/freeSubscription/modals/FreeSubscriptionPaymentInfoModal";
import SubscriptionCooldownWarning from "../../../components/freeSubscription/SubscriptionCooldownWarning";
import InputComponent from "../../../components/InputComponent";
import SaveCards from "../../../components/SaveCards";
import SpinnerComponent from "../../../components/SpinnerComponent/SpinnerComponent";
import { ACCEPTED, FAN, PAYMENT_TYPES } from "../../../helpers/constant";
import { IFanCollection, ILive, ILiveTip, IStripeLivePayload, IStripeLiveTipPayload, IVerifyPromoCode } from "../../../helpers/types";
import useFetchOtherUserInfos from "../../../hooks/userHooks/useFetchOtherUserInfos";
import useFetchUserInfos from "../../../hooks/userHooks/useFetchUserInfos";
import { updateLivePayment } from "../../../redux/lives/livesSlice";
import { AppDispatch } from "../../../redux/store";
import { getOtherUserInfos, updateOtherUserEventPayment } from "../../../redux/users/usersSlice";
import { liveService, mediapushService, messageService, promotionService, subscriptionsService, userService, utilService } from "../../../services";
import { collectionService } from "../../../services/collection.service";
import { SavedCardServices } from "../../../services/savedCard.service";
import { settingService } from "../../../services/settings.service";
import { socket } from "../../../socket";
import { PAYMENT_ERROR_MESSAGES, SHIFT4_AS_DEFAULT_PAYMENT_GATEWAY } from "../../../utls/constants";
import { formatCardNumber } from "../../../utls/FunctionsUtil";
import "./index.less";
import StripeCheckoutForm from "./StripeCheckoutForm";

interface ApplePayData {
  _canMakePaymentAvailability: any;
}

const FanPaymentPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [Key, setKey] = useState("");
  const { currentUser } = useFetchUserInfos(true);
  const shouldFetchCountry = useRef(true);
  const creatorId = searchParams.get("creatorId");
  const { otherUser: user } = useFetchOtherUserInfos(creatorId);
  const planId = searchParams.get("planId");
  const type = searchParams.get("type");
  const mediaPushId = searchParams.get("mediaPushId");
  const collectionId = searchParams.get("collectionId");
  const isFromCollection = searchParams.get("isFromCollection");
  const messageId = searchParams.get("messageId");
  const liveId = searchParams.get("liveId");
  const liveTipId = searchParams.get("liveTipId");
  const currentRedirectUrl = searchParams.get("redirectUrl");
  const fromPaymentFailed = searchParams.get("fromPaymentFailed");
  const dispatch = useDispatch<AppDispatch>();

  // Free subscription params
  const isFreeSubscription = user?.userSettings?.isFreeSubscription || false;
  const [isEligibleForFreeSubscription, setIsEligibleForFreeSubscription] = useState<boolean>(false);
  const [isSubscriptionActive, setIsSubscriptionActive] = useState<boolean>(false);
  const [remainingDays, setRemainingDays] = useState<number>(0);
  const [isSecondTimePayment, setIsSecondTimePayment] = useState<boolean>(false);
  const [isSubscribedFree, setIsSubscribedFree] = useState<boolean>(false);
  const [isLoadingSubInfo, setIsLoadingsubInfo] = useState<boolean>(true);

  const [showPaymentInfoModal, setShowPaymentInfoModal] = useState(false);
  const [PromoCode, setPromoCode] = useState("");
  const [PromoCodeDetails, setPromoCodeDetails] = useState<IVerifyPromoCode | null>();
  const [promoCodeDiscount, setPromoCodeDiscount] = useState<number>();
  const [NetPaymentAoumt, setNetPaymentAoumt] = useState<number>(0);
  const [paymentStatus, setpaymentStatus] = useState<string | null>(null);
  const [mediaPushDetails, setMediaPushDetails] = useState<any>({});
  const [collectionDetails, setCollectionDetails] = useState<IFanCollection | null>(null);
  const [liveDetails, setLiveDetails] = useState<ILive | null>(null);
  const [liveTipDetails, setLiveTipDetails] = useState<ILiveTip | null>(null);
  const [applePay, setApplePay] = useState<ApplePayData>();
  const [choosedPlan, setchoosedPlan] = useState(Number);
  // card details
  const [cardNumber, setCardNumber] = useState("");
  const [MonthYear, setMonthYear] = useState("");
  const [cardHolderName, setCardHolderName] = useState<any>({
    firstname: currentUser?.infos.firstName || "",
    lastname: currentUser?.infos.lastName || "",
  });
  const [cvv, setCvv] = useState("");
  const [error, setError] = useState("");
  // card validation
  const cardnumberReg = /^[0-9\s]*$/;
  const CardMonthYearReg = /^[0-9/]*$/;
  const [buy, setBuy] = useState(false);
  const cvvReg = /^\d*$/;
  const currentYear = new Date().getFullYear().toString().substring(2);
  const expCurrentYear = parseInt(currentYear, 10);
  const [month, year] = MonthYear.split("/");
  const [paymentAmount, setPaymentAmount] = useState<number>(0);
  const [paymentMethod, setPaymentMethod] = useState<string>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  // check box
  const [checkboxChecked, setCheckboxChecked] = useState(true);
  const [paymentCheckBox, setPaymentCheckBox] = useState(true);
  const [allCards, setAllCards] = useState<any>([]);
  const [country, setCountry] = useState("");
  const [countries, setCountries] = useState<any[]>([]);
  const [vatCountries, setVatCountries] = useState<any[]>([]);
  const [vatPercentage, setVatPercentage] = useState<any>(0);
  const [selectedCard, setSelectedCard] = useState<any>(null);
  //const [payemntGateway, setPayemntGateway] = useState<any>("shift4");
  const payemntGateway: string = SHIFT4_AS_DEFAULT_PAYMENT_GATEWAY;
  const userCountry = Cookies.get("country");
  const [expiredDateError, setExpiredDateError] = useState<boolean>(false);
  const [isApplePay, setIsApplePay] = useState<boolean>(false);
  const [isApplePaySubscription, setIsApplePaySubscription] = useState<boolean>(false);

  useEffect(() => {
    setCardHolderName({
      firstname: currentUser?.infos.firstName || "",
      lastname: currentUser?.infos.lastName || "",
    });
  }, [currentUser]);

  useEffect(() => {
    if (creatorId && isFreeSubscription) {
      setNetPaymentAoumt(0.1);
      setIsLoadingsubInfo(true);
      subscriptionsService
        .checkSubscriptionEligibility({ creatorId, type: type === "subscription" ? "monthly_subscription" : type })
        .then((data) => {
          setIsLoadingsubInfo(false);
          setIsEligibleForFreeSubscription(data.isEligibleForFreeSubscription);
          setIsSubscriptionActive(data.isSubscriptionActive);
          setRemainingDays(data.remainingDays || 0);
          setIsSecondTimePayment(data.isSecondTimePayment || false);
          setIsSubscribedFree(data.isSubscribedFree || false);
        })
        .catch((error) => {
          setIsLoadingsubInfo(false);
          console.error("Error checking eligibility:", error);
          setIsEligibleForFreeSubscription(false);
          setIsSubscriptionActive(false);
          setRemainingDays(0);
          setIsSecondTimePayment(false);
          setIsSubscribedFree(false);
        });
    } else {
      setIsLoadingsubInfo(false);
    }
  }, [creatorId, isFreeSubscription, type]);

  useEffect(() => {
    if (paymentStatus === "success" && creatorId) {
      dispatch(getOtherUserInfos(creatorId));
    }
  }, [paymentStatus]);

  if (Key !== "Backspace") {
    if (cardNumber.length === 4 || cardNumber.length === 9 || cardNumber.length === 14) {
      setCardNumber(cardNumber + " ");
    }
    if (MonthYear.length === 2) {
      setMonthYear(MonthYear + "/");
    }
  }

  // subsrcibe details
  const subscribeDetails = {
    creatorId: creatorId,
    type: planId,
    cardNumber: selectedCard ? NaN : parseInt(cardNumber.replace(/\s/g, "")),
    expiryMonth: selectedCard ? NaN : parseInt(month),
    expiryYear: selectedCard ? NaN : 2000 + parseInt(year),
    cvv: selectedCard ? NaN : parseInt(cvv),
    paymentGateway: payemntGateway,
    promoCode: PromoCode,
    country: country,
    cardHolderName: selectedCard ? "" : `${cardHolderName?.firstname} ${cardHolderName?.lastname}`,
    savedCard: paymentCheckBox,
    isCardToken: selectedCard ? true : false,
    token: selectedCard ? selectedCard?.id : "",
  };

  const handleCheckboxChange = () => {
    setCheckboxChecked(!checkboxChecked);
  };

  useEffect(() => {
    getCurrentPaymentGateway();
    userService
      .getVatCountries()
      .then((data: any) => {
        setVatCountries(data?.list);
      })
      .catch((error: any) => {
        message.error(error || t("something-went-wrong"));
      });
    utilService
      .getPhoneCoutries()
      .then((data: any) => {
        setCountries(data);
      })
      .catch((error: any) => {
        message.error(error || t("something-went-wrong"));
      });
  }, []);

  useEffect(() => {
    if (userCountry && userCountry !== null) {
      setCountry(userCountry);
      const selected = vatCountries?.find((item: any) => item.country === userCountry);
      if (selected) {
        setVatPercentage(selected?.vat);
      } else {
        setVatPercentage(0);
      }
    } else {
      if (vatCountries && countries && !country) {
        if (shouldFetchCountry.current) {
          shouldFetchCountry.current = false;
          utilService.fetchUserCountry().then((res: any) => {
            if (res) {
              setCountry(res);
              Cookies.set("country", res, { expires: 1 });
            }
          });
        }
      }
    }
  }, [vatCountries, countries, userCountry]);

  // choosed plan
  useEffect(() => {
    userService
      .getCreatorMonetizations(creatorId)
      .then((res) => {
        const monetizationData = res as {
          monthlyPrice: 0;
          trimestrialPrice: 0;
          half_yearlyPrice: 0;
          yearlyPrice: 0;
        };
        if (planId === "monthly") {
          setchoosedPlan(monetizationData.monthlyPrice);
        } else if (planId === "trimestrial") {
          setchoosedPlan(monetizationData.trimestrialPrice);
        } else if (planId === "half-yearly") {
          setchoosedPlan(monetizationData.half_yearlyPrice);
        } else if (planId === "yearly") {
          setchoosedPlan(monetizationData.yearlyPrice);
        }
      })
      .catch((error) => {});
    getAllCards();
  }, []);

  const getAllCards = async () => {
    await SavedCardServices.allSavedCards()
      .then((res: any) => {
        setAllCards(res?.data?.cards || []);
      })
      .catch((e: any) => {
        console.log(e?.message);
        message.error(t("something-want-wrong"));
      });
  };

  useEffect(() => {
    setPaymentAmount(choosedPlan);
  }, [choosedPlan]);

  // stripe media push details
  const stripeMediaPushDetails = {
    mediaPushId: mediaPushId,
    cardNumber: selectedCard ? NaN : parseInt(cardNumber.replace(/\s/g, "")),
    expiryMonth: selectedCard ? NaN : parseInt(month),
    expiryYear: selectedCard ? NaN : 2000 + parseInt(year),
    cvv: selectedCard ? NaN : parseInt(cvv),
    paymentGateway: payemntGateway,
    promoCode: PromoCode,
    country: country,
    cardHolderName: selectedCard ? "" : `${cardHolderName?.firstname} ${cardHolderName?.lastname}`,
    savedCard: paymentCheckBox,
    isCardToken: selectedCard ? true : false,
    token: selectedCard ? selectedCard?.id : "",
  };

  // stripe media push details
  const stripeCollectionDetails = {
    collectionId: collectionId,
    cardNumber: selectedCard ? NaN : parseInt(cardNumber.replace(/\s/g, "")),
    expiryMonth: selectedCard ? NaN : parseInt(month),
    expiryYear: selectedCard ? NaN : 2000 + parseInt(year),
    cvv: selectedCard ? NaN : parseInt(cvv),
    paymentGateway: payemntGateway,
    promoCode: PromoCode,
    country: country,
    cardHolderName: selectedCard ? "" : `${cardHolderName?.firstname} ${cardHolderName?.lastname}`,
    savedCard: paymentCheckBox,
    isCardToken: selectedCard ? true : false,
    token: selectedCard ? selectedCard?.id : "",
  };

  const livePaymentDetails: IStripeLivePayload = {
    liveId,
    cardNumber: selectedCard ? NaN : parseInt(cardNumber.replace(/\s/g, "")),
    expiryMonth: selectedCard ? NaN : parseInt(month),
    expiryYear: selectedCard ? NaN : 2000 + parseInt(year),
    cvv: selectedCard ? NaN : parseInt(cvv),
    paymentGateway: payemntGateway,
    country: country,
    cardHolderName: selectedCard ? "" : `${cardHolderName?.firstname} ${cardHolderName?.lastname}`,
    savedCard: paymentCheckBox,
    isCardToken: selectedCard ? true : false,
    token: selectedCard ? selectedCard?.id : "",
  };

  const liveTipPaymentDetails: IStripeLiveTipPayload = {
    liveTipId,
    cardNumber: selectedCard ? NaN : parseInt(cardNumber.replace(/\s/g, "")),
    expiryMonth: selectedCard ? NaN : parseInt(month),
    expiryYear: selectedCard ? NaN : 2000 + parseInt(year),
    cvv: selectedCard ? NaN : parseInt(cvv),
    paymentGateway: payemntGateway,
    country: country,
    cardHolderName: selectedCard ? "" : `${cardHolderName?.firstname} ${cardHolderName?.lastname}`,
    savedCard: paymentCheckBox,
    isCardToken: selectedCard ? true : false,
    token: selectedCard ? selectedCard?.id : "",
  };

  // subscribe btn
  const subscribe = async (token: any) => {
    let mainAmount = calculateAmount();
    if (!mainAmount || (Number(mainAmount) < 1 && !isFreeSubscription && !isEligibleForFreeSubscription && !isSubscribedFree)) {
      message.error(t("no-amount"));
      setIsLoading(false);
      return;
    }
    if (selectedCard === null && payemntGateway !== "stripe") {
      if (!cardNumber || !cvv || !MonthYear) {
        return message.warning("Please Fill all Fields");
      }
      if (cvv.length < 3) {
        return message.warning("Enter Valid CVV");
      }
    }
    if (error) {
      setIsLoading(false);
      return message.warning(error);
    }
    setIsLoading(true);
    const userPayload = await utilService.fetchClientDetails();
    if (type === PAYMENT_TYPES.MEDIA_PUSH) {
      if (isFreeSubscription && !isSubscriptionActive && isEligibleForFreeSubscription && mediaPushDetails?.isPrivateMediaPush) {
        const payload = {
          ...stripeMediaPushDetails,
          purchaseId: mediaPushId,
          type: PAYMENT_TYPES.MEDIA_PUSH,
          creatorId,
          ...userPayload,
        };
        subscriptionsService.freeSubscriptionPaymentStrategy(payload).then((res) => {
          setIsLoading(false);
          if ((res.statusCode === 400 || res.statusCode === 500) && PAYMENT_ERROR_MESSAGES.includes(res.message)) {
            return message.error(t(res.message));
          }
          if (res?.data?.transaction?.redirectUrl) {
            const { token, transactionId, transactionId2, redirectUrl } = res.data.transaction;
            Cookies.set(
              "subscription_data",
              JSON.stringify({
                token: token?.id,
                transactionId,
                transactionId2,
                combinedPayment: true,
                creatorId,
                planId,
                type,
                username: user?.infos.username,
                messageId: messageId,
                userType: FAN,
                isToDeliverMedia: true,
                mediaPushId: stripeMediaPushDetails?.mediaPushId,
                redirectUrl: currentRedirectUrl,
              })
            );
            window.location.href = redirectUrl;
          } else {
            if (res?.data?.transaction?.status === "success") {
              setpaymentStatus(res?.data?.transaction?.status);
            } else {
              setpaymentStatus("error");
            }
          }
        });
      } else {
        mediapushService.stripeMediaPush({ ...stripeMediaPushDetails, token, ...userPayload }).then((res) => {
          setIsLoading(false);
          if (res.statusCode === 400 && PAYMENT_ERROR_MESSAGES.includes(res.message)) {
            return message.error(t(res.message));
          }
          if (res?.data?.transaction?.redirectUrl) {
            const { token, transactionId, redirectUrl } = res.data.transaction;
            Cookies.set(
              "subscription_data",
              JSON.stringify({
                token: token?.id,
                transactionId,
                creatorId,
                planId,
                type,
                username: user?.infos.username,
                messageId: messageId,
                userType: FAN,
                isToDeliverMedia: true,
                mediaPushId: stripeMediaPushDetails?.mediaPushId,
                redirectUrl: currentRedirectUrl,
              })
            );
            window.location.href = redirectUrl;
          } else {
            if (res?.data?.transaction?.status === "success") {
              setpaymentStatus(res?.data?.transaction?.status);
              messageService.updateMessageStatus({ messageId: messageId!, action: ACCEPTED, userType: FAN, isToDeliverMedia: true }).catch(() => {});
            } else {
              setpaymentStatus("error");
            }
          }
        });
      }
    } else if (type === "collection") {
      if (isFreeSubscription && !isSubscriptionActive && isEligibleForFreeSubscription) {
        const payload = {
          ...stripeCollectionDetails,
          purchaseId: collectionId,
          type: "collection",
          creatorId,
          ...userPayload,
        };
        subscriptionsService.freeSubscriptionPaymentStrategy(payload).then((res) => {
          setIsLoading(false);
          if ((res.statusCode === 400 || res.statusCode === 500) && PAYMENT_ERROR_MESSAGES.includes(res.message)) {
            return message.error(t(res.message));
          }
          if (res?.data?.transaction?.redirectUrl) {
            const { token, transactionId, transactionId2, redirectUrl } = res.data.transaction;
            Cookies.set(
              "subscription_data",
              JSON.stringify({
                token: token?.id,
                transactionId,
                transactionId2,
                combinedPayment: true,
                creatorId,
                planId,
                collectionId,
                type,
                username: user?.infos.username,
                userType: FAN,
                redirectUrl: currentRedirectUrl,
              })
            );
            window.location.href = redirectUrl;
          } else {
            if (res?.data?.transaction?.status === "success") {
              setpaymentStatus(res?.data?.transaction?.status);
            } else {
              setpaymentStatus("error");
            }
          }
        });
      } else {
        collectionService.stripeCollection({ ...stripeCollectionDetails, token, ...userPayload }).then((res) => {
          setIsLoading(false);
          if (res.statusCode === 400 && PAYMENT_ERROR_MESSAGES.includes(res.message)) {
            return message.error(t(res.message));
          }
          if (res?.data?.transaction?.redirectUrl) {
            const { token, transactionId, redirectUrl } = res.data.transaction;
            Cookies.set(
              "subscription_data",
              JSON.stringify({
                token: token?.id,
                transactionId,
                creatorId,
                planId,
                collectionId,
                type,
                username: user?.infos.username,
                userType: FAN,
                redirectUrl: currentRedirectUrl,
              })
            );
            window.location.href = redirectUrl;
          } else {
            if (res?.data?.transaction?.status === "success") {
              setpaymentStatus(res?.data?.transaction?.status);
            } else {
              setpaymentStatus("error");
            }
          }
        });
      }
    } else if (type === "subscription") {
      const subscribeCreators = async (subscribeDetails: any) => {
        setIsLoading(true);
        await subscriptionsService.subscribeCreator({ ...subscribeDetails, token, ...userPayload }).then((response: any) => {
          setIsLoading(false);
          if ((response.statusCode === 400 || response.statusCode === 500) && PAYMENT_ERROR_MESSAGES.includes(response.message)) {
            return message.error(t(response.message));
          }
          if (payemntGateway === "stripe") {
            if (response?.data?.transaction?.status === "success") {
              setpaymentStatus(response?.data?.transaction?.status);
            } else {
              setpaymentStatus("error");
            }
          } else {
            if (response?.data?.enrolled) {
              const { token, transactionId, redirectUrl } = response.data;
              Cookies.set(
                "subscription_data",
                JSON.stringify({
                  token: token?.id,
                  transactionId,
                  creatorId,
                  planId,
                  type,
                  username: user?.infos.username,
                  isFromCollection,
                  redirectUrl: currentRedirectUrl,
                })
              );
              window.location.href = redirectUrl;
            } else {
              setpaymentStatus("error");
            }
          }
        });
      };
      subscribeCreators(subscribeDetails);
    } else if (type === PAYMENT_TYPES.LIVE) {
      if (livePaymentDetails.liveId) {
        liveService.stripeLive({ ...livePaymentDetails, token, ...userPayload }).then((res: any) => {
          setIsLoading(false);
          if (res.statusCode === 400 && PAYMENT_ERROR_MESSAGES.includes(res.message)) {
            return message.error(t(res.message));
          }
          if (res?.transaction?.redirectUrl) {
            const { token, transactionId, redirectUrl } = res.transaction;
            Cookies.set(
              "subscription_data",
              JSON.stringify({
                token: token?.id,
                transactionId,
                creatorId,
                planId,
                type,
                username: user?.infos.username,
                liveId: livePaymentDetails.liveId,
                isSuggested: liveDetails?.isSuggested,
                isScheduled: liveDetails?.startType === "schedule" && !liveDetails?.isStreaming,
              })
            );
            window.location.href = redirectUrl;
          } else {
            if (res?.transaction?.status === "success") {
              setpaymentStatus(res?.transaction?.status);
              dispatch(updateLivePayment({ id: livePaymentDetails.liveId, isSuggested: liveDetails?.isSuggested }));
              dispatch(updateOtherUserEventPayment({ id: creatorId }));
            } else {
              setpaymentStatus("error");
            }
          }
        });
      }
    } else if (type === PAYMENT_TYPES.LIVE_TIP) {
      if (liveTipPaymentDetails.liveTipId) {
        liveService.stripeLiveTip({ ...liveTipPaymentDetails, token, ...userPayload }).then((res: any) => {
          setIsLoading(false);
          if (res.statusCode === 400 && PAYMENT_ERROR_MESSAGES.includes(res.message)) {
            return message.error(t(res.message));
          }
          if (res?.transaction?.redirectUrl) {
            const { token, transactionId, redirectUrl } = res.transaction;
            Cookies.set(
              "subscription_data",
              JSON.stringify({
                token: token?.id,
                transactionId,
                creatorId,
                planId,
                type,
                username: user?.infos.username,
                streamId: liveTipDetails?.streamId,
                amount: liveTipDetails?.amount,
                liveTipId: liveTipPaymentDetails.liveTipId,
                redirectUrl: currentRedirectUrl,
              })
            );
            window.location.href = redirectUrl;
          } else {
            if (res?.transaction?.status === "success") {
              socket.emit("public-stream/update-tip", {
                id: liveTipDetails?.streamId,
                amount: liveTipDetails?.amount,
              });
              setpaymentStatus(res?.transaction?.status);
            } else {
              setpaymentStatus("error");
            }
          }
        });
      }
    }
  };

  useEffect(() => {
    if (liveTipDetails?.streamId) {
      liveService
        .getLiveById(liveTipDetails?.streamId)
        .then((data: ILive) => setLiveDetails(data))
        .catch((error) => console.log(error));
    }
  }, [liveTipDetails]);

  useEffect(() => {
    if (liveTipId) {
      liveService
        .getTipById(liveTipId)
        .then((data: ILiveTip) => setLiveTipDetails(data))
        .catch((error) => console.log(error));
    }
  }, [liveTipId]);

  useEffect(() => {
    if (liveId) {
      liveService
        .getLiveById(liveId)
        .then((data: ILive) => setLiveDetails(data))
        .catch((error) => console.log(error));
    }
  }, [liveId]);

  useEffect(() => {
    if (collectionId) {
      collectionService
        .getFanCollectionDetail(collectionId)
        .then((data: IFanCollection) => setCollectionDetails(data))
        .catch((error) => console.log(error));
    }
  }, [collectionId]);

  useEffect(() => {
    if (mediaPushId) {
      mediapushService
        .getMediaPushPrice(mediaPushId)
        .then((response) => {
          setMediaPushDetails(response);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [mediaPushId]);

  useEffect(() => {
    if (type === PAYMENT_TYPES.MEDIA_PUSH) {
      let price = mediaPushDetails.price;
      if (mediaPushDetails.promo) {
        price = mediaPushDetails.resultPrice;
      }
      setPaymentAmount(price);
    } else if (type === "subscription") {
      setPaymentAmount(choosedPlan);
    }
  });

  useEffect(() => {
    if (selectedCard !== null && checkboxChecked && country) {
      setBuy(true);
    } else {
      if (
        cardNumber.length === 19 &&
        cvv.length === 3 &&
        MonthYear.length === 5 &&
        checkboxChecked &&
        country &&
        cardHolderName.firstname &&
        cardHolderName.lastname
      ) {
        setBuy(true);
      } else {
        setBuy(false);
      }
    }
  }, [cardNumber, cvv, MonthYear, checkboxChecked, country, cardHolderName.firstname, cardHolderName.lastname, selectedCard]);

  const PromoCodeApply = async () => {
    if (type === PAYMENT_TYPES.MEDIA_PUSH && mediaPushDetails?.promo) {
      message.error(t("promo-not-applicable"));
      setPromoCode("");
      return;
    }
    let discountedType = type === "subscription" ? "SUBSCRIBERS" : "MEDIA_PUSH";
    let purchaseID: any = type === "subscription" ? creatorId : mediaPushId || collectionId;
    await promotionService
      .verifyPromoCode(PromoCode, creatorId!, discountedType, purchaseID)
      .then((response) => {
        if ("promoOn" in response) {
          if (
            (response?.promoOn === "SUBSCRIBERS" && type === "subscription") ||
            (response?.promoOn === "MEDIA_PUSH" && (type === PAYMENT_TYPES.MEDIA_PUSH || type === "collection"))
          ) {
            if (response?.discountType === "PERCENTAGE") {
              if (type === "subscription" && choosedPlan - (choosedPlan * response.discount) / 100 < 5) {
                setPromoCodeDetails(response as IVerifyPromoCode);
                setPromoCodeDiscount(choosedPlan - 5);
                message.warning(t("minimum-amount-5"));
                return;
              } else if (type === PAYMENT_TYPES.MEDIA_PUSH && mediaPushDetails.price - (mediaPushDetails.price * response.discount) / 100 < 1) {
                setPromoCodeDetails(response as IVerifyPromoCode);
                setPromoCodeDiscount(mediaPushDetails.promo ? mediaPushDetails.resultPrice - 1 : mediaPushDetails.price - 1);
                message.warning(t("minimum-amount"));
                return;
              } else if (
                type === "collection" &&
                collectionDetails &&
                collectionDetails.price - (collectionDetails.price * response.discount) / 100 < 1
              ) {
                setPromoCode("");
                setPromoCodeDetails(null);
                setPromoCodeDiscount(0);
                message.warning(t("promo-price-exceed"));
                return;
              } else {
                setPromoCodeDetails(response as IVerifyPromoCode);
                if (type === "subscription") {
                  setPromoCodeDiscount((choosedPlan * response.discount) / 100);
                } else {
                  setPromoCodeDiscount((mediaPushDetails.price * response.discount) / 100);
                }
                message.success(t("promo-code-applied"));
              }
            } else {
              if (type === "subscription" && choosedPlan - response.discount < 5) {
                setPromoCodeDetails(response as IVerifyPromoCode);
                setPromoCodeDiscount(choosedPlan - 5);
                message.warning(t("minimum-amount-5"));
                return;
              } else if (
                type === PAYMENT_TYPES.MEDIA_PUSH && mediaPushDetails.promo
                  ? mediaPushDetails.resultPrice
                  : mediaPushDetails.price - response.discount < 1
              ) {
                // setPromoCode("");
                setPromoCodeDetails(response as IVerifyPromoCode);
                setPromoCodeDiscount(mediaPushDetails.promo ? mediaPushDetails.resultPrice - 1 : mediaPushDetails.price - 1);
                message.warning(t("minimum-amount"));
                return;
              } else if (type === "collection" && collectionDetails && collectionDetails.price - response.discount < 1) {
                setPromoCode("");
                setPromoCodeDetails(null);
                setPromoCodeDiscount(0);
                message.warning(t("promo-price-exceed"));
                return;
              } else {
                setPromoCodeDetails(response as IVerifyPromoCode);
                setPromoCodeDiscount(response.discount);
                message.success(t("promo-code-applied"));
              }
            }
          } else {
            message.error(t("enter-valid-promo-code"));
            setPromoCode("");
            setPromoCodeDiscount(0);
            setPromoCodeDetails(null);
          }
        } else if ("error" in response) {
          setPromoCode("");
          setPromoCodeDiscount(0);
          setPromoCodeDetails(null);
          if (PromoCodeDetails) {
            setNetPaymentAoumt(0);
          }
          if (response.error) {
            message.error(t("enter-valid-promo-code"));
          } else {
            message.error(t("enter-valid-promo-code"));
          }
        }
      })
      .catch((error) => {
        setPromoCode("");
        message.error(t("enter-valid-promo-code"));
      });
  };

  useEffect(() => {
    if (PromoCodeDetails?.discountType === "PERCENTAGE") {
      if (type === "subscription") {
        setNetPaymentAoumt(choosedPlan - (choosedPlan * PromoCodeDetails.discount) / 100);
      } else if (type === PAYMENT_TYPES.MEDIA_PUSH) {
        setNetPaymentAoumt(mediaPushDetails.price - (mediaPushDetails.price * PromoCodeDetails.discount) / 100);
      } else if (type === "collection" && collectionDetails) {
        setPromoCodeDiscount((collectionDetails.price * PromoCodeDetails.discount) / 100);
        setNetPaymentAoumt(collectionDetails.price - (collectionDetails.price * PromoCodeDetails.discount) / 100);
      }
    } else if (PromoCodeDetails?.discountType === "CURRENCY") {
      if (type === "subscription") {
        setNetPaymentAoumt(choosedPlan - PromoCodeDetails.discount);
      } else if (type === PAYMENT_TYPES.MEDIA_PUSH) {
        setNetPaymentAoumt(mediaPushDetails.price - PromoCodeDetails.discount);
      } else if (type === "collection" && collectionDetails) {
        setPromoCodeDiscount(PromoCodeDetails.discount);
        setNetPaymentAoumt(collectionDetails.price - PromoCodeDetails.discount);
      }
    }
  }, [PromoCodeDetails, applePay]);

  function getLabel(type: any) {
    switch (type) {
      case PAYMENT_TYPES.MEDIA_PUSH:
        return `${t("Media-Push-label-to")} ${user ? user.infos.name : ""}`;
      case PAYMENT_TYPES.COLLECTION:
        return `${t("collection-label-to")} ${user ? user.infos.name : ""}`;
      case PAYMENT_TYPES.SUBSCRIPTION:
        return `${t("subscribe-label-to")} ${user ? user.infos.name : ""}`;
      case PAYMENT_TYPES.LIVE:
        return "live";
      case PAYMENT_TYPES.LIVE_TIP:
        return `${t("give-a-tip-to")} ${user ? user.infos.name : ""}`;
      default:
        return "";
    }
  }

  useEffect(() => {
    if (country) {
      const selected = vatCountries?.find((item: any) => item.country === country);
      if (selected) {
        setVatPercentage(selected?.vat);
      } else {
        setVatPercentage(0);
      }
    }
  }, [country]);

  const handleSelectCard = (item: any) => {
    if (selectedCard === item) {
      setSelectedCard(null);
    } else {
      setSelectedCard(item);
    }
  };

  const fromPayment = sessionStorage.getItem("payment-page") === "True";

  const handleNavigate = () => {
    if (fromPaymentFailed) {
      if (currentRedirectUrl) {
        return navigate("/" + currentRedirectUrl);
      }
    } else if (fromPayment) {
      if (type === "subscription") {
        sessionStorage.removeItem("payment-page");
        return navigate(`/p/${user?.infos.username}`);
      } else {
        return navigate(-1);
      }
    } else {
      return navigate(-1);
    }
  };

  const calculateAmount = () => {
    let baseAmount;
    if (type === "subscription") {
      baseAmount = isFreeSubscription && isEligibleForFreeSubscription && !isSubscribedFree ? 0.1 : choosedPlan;
    } else if (type === PAYMENT_TYPES.MEDIA_PUSH) {
      baseAmount = mediaPushDetails.promo ? mediaPushDetails.resultPrice : mediaPushDetails.price;
    } else if (type === "collection") {
      baseAmount = collectionDetails && collectionDetails.price;
    } else if (type === PAYMENT_TYPES.LIVE) {
      baseAmount = liveDetails?.amount || 0;
    } else if (type === PAYMENT_TYPES.LIVE_TIP) {
      baseAmount = liveTipDetails?.amount || 0;
    } else {
      baseAmount = 0;
    }

    if (promoCodeDiscount) {
      baseAmount -= promoCodeDiscount;
    }

    if (type === "subscription" && baseAmount < 5 && !isFreeSubscription) {
      baseAmount = 5;
    }

    return baseAmount?.toFixed(2);
  };

  const formatNumber = (number: string) => {
    return number
      .replace(/\s?/g, "")
      .replace(/(\d{4})/g, "$1 ")
      .trim();
  };

  useEffect(() => {
    const formattedCardNumber = formatCardNumber(cardNumber);
    if (formattedCardNumber !== cardNumber) {
      setCardNumber(formattedCardNumber);
    }
  }, [cardNumber]);

  const calculateVatAmount = (amount: number): string => {
    if (type === "subscription") {
      if (isFreeSubscription && isEligibleForFreeSubscription && !isSubscribedFree) {
        amount = 0.1;
      } else {
        amount = amount < 5 ? 5 : amount;
      }
    } else {
      amount = amount < 1 ? 1 : amount;
    }

    const result = (amount * vatPercentage) / 100;
    return result < 0 ? "0.00" : result.toFixed(2);
  };

  const getCurrentPaymentGateway = async () => {
    await settingService.getPayentGateway().then((res: any) => {
      if (res?.applePayPaysafe) {
        if (res?.applePayPaysafe === "enable") {
          setIsApplePay(true);
        } else {
          setIsApplePay(false);
        }
      }

      //Apple Pay Subscription
      if (res?.applePaySubscription) {
        if (res?.applePaySubscription === "enable") {
          setIsApplePaySubscription(true);
        } else {
          setIsApplePaySubscription(false);
        }
      }
    });
  };

  //NOTE: FOR OTHER PAYMENT TYPE EXCEPT SUBSCRIPTION
  const handleApplePayPayment = async (token: any) => {
    const userPayload = await utilService.fetchClientDetails();
    setIsLoading(true);
    if (type === PAYMENT_TYPES.COLLECTION) {
      const data = {
        collectionId: collectionId,
        applePay: {
          applePayPaymentToken: token,
        },
        paymentGateway: "paysafe_applepay",
        country: country || null,
        promoCode: PromoCode,
      };

      collectionService.paysafeApplePayCollection({ ...data, ...userPayload }).then((res) => {
        setIsLoading(false);
        if (res.statusCode === 400 && PAYMENT_ERROR_MESSAGES.includes(res.message)) {
          return message.error(t(res.message));
        }
        if (res?.data?.status === "success") {
          setpaymentStatus(res?.data?.status);
        } else {
          setpaymentStatus("error");
        }
      });
    } else if (type === PAYMENT_TYPES.MEDIA_PUSH) {
      const data = {
        mediaPushId: mediaPushId,
        applePay: {
          applePayPaymentToken: token,
        },
        paymentGateway: "paysafe_applepay",
        country: country || null,
        promoCode: PromoCode,
      };
      mediapushService.paysafeApplePayMediaPush({ ...data, ...userPayload }).then((res) => {
        setIsLoading(false);
        if (res.statusCode === 400 && PAYMENT_ERROR_MESSAGES.includes(res.message)) {
          return message.error(t(res.message));
        }
        if (res?.data?.status === "success") {
          setpaymentStatus(res?.data?.status);
          messageService.updateMessageStatus({ messageId: messageId!, action: ACCEPTED, userType: FAN, isToDeliverMedia: true }).catch(() => {});
        } else {
          setpaymentStatus("error");
        }
      });
    } else if (type === PAYMENT_TYPES.LIVE) {
      let data: any = {
        applePay: {
          applePayPaymentToken: token,
        },
        paymentGateway: "paysafe_applepay",
        country: country || null,
        promoCode: PromoCode,
        liveId: liveId,
      };

      liveService.paysafeApplePayStream({ ...data, ...userPayload }).then((res: any) => {
        setIsLoading(false);
        if (res.statusCode === 400 && PAYMENT_ERROR_MESSAGES.includes(res.message)) {
          return message.error(t(res.message));
        }
        if (res?.data?.status === "success") {
          setpaymentStatus(res?.data?.status);
          dispatch(updateLivePayment({ id: livePaymentDetails.liveId, isSuggested: liveDetails?.isSuggested }));
          dispatch(updateOtherUserEventPayment({ id: creatorId }));
        } else {
          setpaymentStatus("error");
        }
      });
    } else if (type === PAYMENT_TYPES.LIVE_TIP) {
      let data: any = {
        applePay: {
          applePayPaymentToken: token,
        },
        paymentGateway: "paysafe_applepay",
        country: country || null,
        promoCode: PromoCode,
        liveTipId: liveTipId,
      };

      liveService.paysafeApplePayStreamTip({ ...data, ...userPayload }).then((res: any) => {
        setIsLoading(false);
        if (res.statusCode === 400 && PAYMENT_ERROR_MESSAGES.includes(res.message)) {
          return message.error(t(res.message));
        }
        if (res?.data?.status === "success") {
          socket.emit("public-stream/update-tip", {
            id: liveTipDetails?.streamId,
            amount: liveTipDetails?.amount,
          });
          setpaymentStatus(res?.data?.status);
        } else {
          setpaymentStatus("error");
        }
      });
    }
  };

  //NOTE: ONLY FOR SUBSCRIPTION
  const handlePaySubscribe = async (billingDetails: any, token: any) => {
    const userPayload = await utilService.fetchClientDetails();

    const payload = {
      creatorId: creatorId,
      type: planId,
      applePay: {
        applePayPaymentToken: token,
      },
      promoCode: PromoCode,
      ...userPayload,
      billingDetails,
      country,
    };

    setIsLoading(true);
    try {
      if (
        isFreeSubscription &&
        !isSubscriptionActive &&
        ((type === PAYMENT_TYPES.MEDIA_PUSH && mediaPushDetails?.isPrivateMediaPush) || type === PAYMENT_TYPES.COLLECTION)
      ) {
        const data = {
          ...payload,
          type,
          purchaseId: type === PAYMENT_TYPES.COLLECTION ? collectionId : mediaPushId,
        };
        mediapushService.paysafeApplePayCombinePurchase(data).then((res: any) => {
          setIsLoading(false);
          if (res.statusCode === 400 && PAYMENT_ERROR_MESSAGES.includes(res.message)) {
            return message.error(t(res.message));
          }
          if (res?.data?.transaction?.status === "success") {
            setpaymentStatus(res?.data?.transaction?.status);

            if (type === PAYMENT_TYPES.MEDIA_PUSH) {
              messageService
                .updateMessageStatus({
                  messageId: messageId!,
                  action: ACCEPTED,
                  userType: FAN,
                  isToDeliverMedia: true,
                })
                .catch(() => {});
            }
          } else {
            setpaymentStatus("error");
          }
        });
      } else {
        subscriptionsService.paysafeApplePaySubscription(payload).then((res: any) => {
          setIsLoading(false);
          sessionStorage.setItem("payment-page", "True");
          if (res.statusCode === 400 && PAYMENT_ERROR_MESSAGES.includes(res.message)) {
            return message.error(t(res.message));
          }
          if (res?.data?.transaction?.status === "success") {
            setpaymentStatus(res?.data?.transaction?.status);
          } else {
            setpaymentStatus("error");
          }
        });
      }
    } catch (error) {
      console.log("error :>> ", error);
      message.error("Something went wrong!");
    }
  };

  const calculateApplePayAmount = () => {
    let baseAmount = 0;

    // Step 1: Get base amount by type
    switch (type) {
      case PAYMENT_TYPES.SUBSCRIPTION:
        baseAmount = isFreeSubscription && isEligibleForFreeSubscription && !isSubscribedFree ? 0.1 : choosedPlan;
        break;
      case PAYMENT_TYPES.MEDIA_PUSH:
        baseAmount = mediaPushDetails.promo ? mediaPushDetails.resultPrice : mediaPushDetails.price;
        break;
      case PAYMENT_TYPES.COLLECTION:
        baseAmount = collectionDetails?.price || 0;
        break;
      case PAYMENT_TYPES.LIVE:
        baseAmount = liveDetails?.amount || 0;
        break;
      case PAYMENT_TYPES.LIVE_TIP:
        baseAmount = liveTipDetails?.amount || 0;
        break;
      default:
        baseAmount = 0;
    }

    // Step 2: Apply promo discount if present
    if (promoCodeDiscount) {
      baseAmount -= promoCodeDiscount;
    }

    // Step 3: Apply VAT if needed
    //NOTE: EXCLUDE THE VAT IF WE ARE PAYING FREE SUBSCRIPTION
    const check =
      type !== "subscription" ||
      (type === "subscription" && !isFreeSubscription && !isEligibleForFreeSubscription) ||
      (isSubscribedFree && !isEligibleForFreeSubscription);

    if (vatPercentage && check) {
      baseAmount += Number(calculateVatAmount(baseAmount));
    }

    // Step 4: Enforce minimum for subscription
    let finalAmount = baseAmount;
    if (type === PAYMENT_TYPES.SUBSCRIPTION && finalAmount < 5 && !isFreeSubscription && !isEligibleForFreeSubscription && isSubscribedFree) {
      finalAmount = 5;
    }

    return Number(finalAmount).toFixed(2);
  };

  /**
   * DOESN'T NEED TO SHOW THE CARDS IF
   * NOT EXIST
   * PAYMENT METHOD IS NOT SHIFT4
   * WE ARE PAYING FOR A SUBSCRIPTION
   * FAN SUBSCRIBED AND ITS THE SECOND PAYMENT
   * FAN IS NOT SUBSCRIBED AND HE PAYING A COMBINATION PAYMENT WITH A COLLECTION OR PRIVATE MEDIA
   */
  const handleShowSavedCards = () => {
    if (allCards.length === 0) {
      return false;
    }
    if (payemntGateway !== "shift4") {
      return false;
    }
    if (type === PAYMENT_TYPES.SUBSCRIPTION) {
      return false;
    }
    if (isFreeSubscription && [PAYMENT_TYPES.COLLECTION, PAYMENT_TYPES.MEDIA_PUSH, PAYMENT_TYPES.LIVE].includes(type!)) {
      if (isSecondTimePayment && isSubscriptionActive) {
        return false;
      } else if (
        isEligibleForFreeSubscription &&
        // !isSubscribedFree &&
        !isSubscriptionActive &&
        (type === PAYMENT_TYPES.COLLECTION || (type === PAYMENT_TYPES.MEDIA_PUSH && mediaPushDetails?.isPrivateMediaPush))
      ) {
        return false;
      }
    }

    return true;
  };

  const handleApplePayCombinePurchase = () => {
    if (!user || !isApplePaySubscription) return false;

    if (isFreeSubscription && (type === PAYMENT_TYPES.MEDIA_PUSH || type === PAYMENT_TYPES.COLLECTION)) {
      return true;
    }
    if (type === PAYMENT_TYPES.SUBSCRIPTION) {
      return true;
    }

    return false;
  };

  const handlePaymentMethod = (billingDetails: any, token: any) => {
    if (
      type === PAYMENT_TYPES.SUBSCRIPTION ||
      ((type === PAYMENT_TYPES.COLLECTION || (type === PAYMENT_TYPES.MEDIA_PUSH && mediaPushDetails?.isPrivateMediaPush)) &&
        isFreeSubscription &&
        isEligibleForFreeSubscription &&
        !isSubscribedFree)
    ) {
      handlePaySubscribe(billingDetails, token);
    } else {
      handleApplePayPayment(token);
    }
  };

  const handleCheck = (isPromo = false) => {
    if (
      PAYMENT_TYPES.COLLECTION === type ||
      (type === PAYMENT_TYPES.MEDIA_PUSH && mediaPushDetails.isPrivateMediaPush) ||
      (isPromo && PAYMENT_TYPES.SUBSCRIPTION === type)
    ) {
      if (isFreeSubscription && isEligibleForFreeSubscription && !isSubscriptionActive) {
        return true;
      }
    }
    return false;
    // isFreeSubscription &&
    //                 isEligibleForFreeSubscription &&
    //                 !isSubscriptionActive &&
    //                 (type === PAYMENT_TYPES.COLLECTION || type === PAYMENT_TYPES.MEDIA_PUSH) &&
  };

  return (
    <Spin spinning={isLoading} style={{ maxHeight: "100%" }} indicator={<SpinnerComponent />}>
      <Layout>
        <Layout.Content className="content fanSubscribeContentWrap gradient-background">
          <Col>
            <Row>
              {/* <div className="fanSubscribeHeaderBg"></div> */}
              <div className="fanSubscribeHeaderContent">
                <Row className="relative justify-content-center">
                  {/* <ArrowLeftIconComponent top={6} navigateTo={handleNavigate()} /> */}
                  <img className="header-arrow-left" src={NewArrowLeftIcon} alt="arrow left" style={{ top: 6 }} onClick={handleNavigate} />
                  <Row className="ml-20" align="middle">
                    <img src={LockIcon} width={20} alt="arrow left" />
                    <Typography.Text className="ml-10 header-title-black-28">{t("secure-payment")}</Typography.Text>
                  </Row>
                </Row>
                {!isLoadingSubInfo && isFreeSubscription && !isEligibleForFreeSubscription && type === PAYMENT_TYPES.SUBSCRIPTION && (
                  <div className="subscription-cooldown-warning-wrapper">
                    <SubscriptionCooldownWarning remainingDays={remainingDays} />
                  </div>
                )}
                <Row className="mt-20">
                  <Typography.Text className="fanPaymentRecapLabel">{t("summary")}</Typography.Text>
                </Row>
                <Row className="d-flex justify-content-between items-center mt-10">
                  {!isLoadingSubInfo && isFreeSubscription && isEligibleForFreeSubscription && type === PAYMENT_TYPES.SUBSCRIPTION ? (
                    <>
                      <div className="free-subscription-label-container">
                        <Typography.Text className="fanPaymentMiddleLabel">{t("free-subscription-label")}</Typography.Text>
                        <Typography.Text className="free-subscription-this-month">{t("this-month")}</Typography.Text>
                      </div>
                      <div className="free-subscription-price-container">
                        <Typography.Text className="fanPaymentMiddleLabel strikethrough">{choosedPlan} €</Typography.Text>
                        <Typography.Text className="fanPaymentMiddleLabel free-label">{t("free")}</Typography.Text>
                      </div>
                    </>
                  ) : (
                    <>
                      <Typography.Text className="fanPaymentMiddleLabel">
                        {`${
                          planId === "monthly"
                            ? t("monthly-label") + " "
                            : planId === "trimestrial"
                              ? t("three-months-label") + " "
                              : planId === "half-yearly"
                                ? t("six-months-label") + " "
                                : planId === "yearly"
                                  ? t("yearly-label") + " "
                                  : ""
                        }${
                          type === PAYMENT_TYPES.MEDIA_PUSH
                            ? t("Media-Push-label")
                            : type === PAYMENT_TYPES.SUBSCRIPTION
                              ? t("subscribe-label")
                              : type === PAYMENT_TYPES.COLLECTION
                                ? t("collection")
                                : type === PAYMENT_TYPES.LIVE
                                  ? t("live")
                                  : type === PAYMENT_TYPES.LIVE_TIP
                                    ? t("live-tip-to-label")
                                    : ""
                        } ` + `${user ? user.infos.name : ""}`}
                      </Typography.Text>
                      <Typography.Text className="fanPaymentMiddleLabel">
                        {type === PAYMENT_TYPES.SUBSCRIPTION
                          ? choosedPlan
                          : type === PAYMENT_TYPES.MEDIA_PUSH
                            ? mediaPushDetails.promo
                              ? mediaPushDetails.resultPrice
                              : mediaPushDetails.price
                            : type === PAYMENT_TYPES.COLLECTION
                              ? collectionDetails?.price
                              : type === PAYMENT_TYPES.LIVE
                                ? liveDetails?.amount
                                : type === PAYMENT_TYPES.LIVE_TIP
                                  ? liveTipDetails?.amount
                                  : ""}{" "}
                        €
                      </Typography.Text>
                    </>
                  )}
                </Row>
                {handleCheck() && (
                  <Row className="d-flex justify-content-between items-center mt-10">
                    <div className="free-subscription-label-container">
                      <Typography.Text className="fanPaymentMiddleLabel">{t("free-subscription-label")}</Typography.Text>
                      <Typography.Text className="free-subscription-this-month">{t("this-month")}</Typography.Text>
                    </div>
                    <div className="free-subscription-price-container">
                      <Typography.Text className="fanPaymentMiddleLabel strikethrough">{choosedPlan} €</Typography.Text>
                      <Typography.Text className="fanPaymentMiddleLabel free-label">{t("free")}</Typography.Text>
                    </div>
                  </Row>
                )}
                {/* {PromoCodeDetails && (
                <Row className="d-flex justify-content-between items-center mt-3">
                  <Typography.Text className="fanPaymentSmallLabel">
                    {t("promo-code-discount")}
                  </Typography.Text>
                  <Typography.Text className="fanPaymentSmallLabel">
                    {promoCodeDiscount && promoCodeDiscount + "€"}
                  </Typography.Text>
                </Row>
              )} */}
                {PromoCodeDetails && (
                  <Row className="d-flex justify-content-between items-center mt-3">
                    <Typography.Text className="fanPaymentMiddleLabel">{t("promo-code-discount")}</Typography.Text>
                    <Typography.Text className="fanPaymentMiddleLabel">{promoCodeDiscount && "-" + promoCodeDiscount + " €"}</Typography.Text>
                  </Row>
                )}
                {country && vatPercentage !== 0 && (
                  <Row className="d-flex justify-content-between items-center mt-3">
                    <Typography.Text className="fanPaymentMiddleLabel tva">{t("including-vat")}</Typography.Text>
                    <Typography.Text className="fanPaymentMiddleLabel tva">
                      {isFreeSubscription && isEligibleForFreeSubscription && type === PAYMENT_TYPES.SUBSCRIPTION
                        ? "0.00"
                        : type === "subscription"
                          ? !promoCodeDiscount
                            ? calculateVatAmount(choosedPlan)
                            : calculateVatAmount(NetPaymentAoumt)
                          : type === PAYMENT_TYPES.MEDIA_PUSH
                            ? mediaPushDetails.promo
                              ? !promoCodeDiscount
                                ? calculateVatAmount(mediaPushDetails.resultPrice)
                                : calculateVatAmount(NetPaymentAoumt)
                              : !promoCodeDiscount
                                ? calculateVatAmount(mediaPushDetails.price)
                                : calculateVatAmount(NetPaymentAoumt)
                            : type === PAYMENT_TYPES.LIVE
                              ? !promoCodeDiscount
                                ? calculateVatAmount(liveDetails?.amount || 0)
                                : ""
                              : type === PAYMENT_TYPES.COLLECTION
                                ? !promoCodeDiscount
                                  ? calculateVatAmount(collectionDetails?.price || 0)
                                  : calculateVatAmount(NetPaymentAoumt)
                                : type === PAYMENT_TYPES.LIVE_TIP
                                  ? !promoCodeDiscount
                                    ? calculateVatAmount(liveTipDetails?.amount || 0)
                                    : ""
                                  : ""}{" "}
                      €
                    </Typography.Text>
                  </Row>
                )}
                {/* {promoCodeDiscount && vatPercentage !== 0 && (
                  <>
                    <hr></hr>
                    <Row className="d-flex justify-content-between items-center mt-3">
                      <Typography.Text className="fanPaymentMiddleLabel">{t("total-amount")}</Typography.Text>
                      <Typography.Text className="fanPaymentMiddleLabel">
                        {(NetPaymentAoumt + (NetPaymentAoumt * vatPercentage) / 100).toFixed(2) + " €"}
                      </Typography.Text>
                    </Row>
                  </>
                )}
                {!promoCodeDiscount && vatPercentage !== 0 && (
                  <>
                    <hr></hr>
                    <Row className="d-flex justify-content-between items-center mt-3">
                      <Typography.Text className="fanPaymentMiddleLabel">{t("total-amount")}</Typography.Text>
                      <Typography.Text className="fanPaymentMiddleLabel">
                        {type === "subscription"
                          ? !promoCodeDiscount
                            ? (choosedPlan * (1 + vatPercentage / 100)).toFixed(2)
                            : (NetPaymentAoumt * (1 + vatPercentage / 100)).toFixed(2)
                          : type === PAYMENT_TYPES.MEDIA_PUSH
                            ? mediaPushDetails.promo
                              ? !promoCodeDiscount
                                ? (mediaPushDetails.resultPrice * (1 + vatPercentage / 100)).toFixed(2)
                                : (NetPaymentAoumt * (1 + vatPercentage / 100)).toFixed(2)
                              : !promoCodeDiscount
                                ? (mediaPushDetails.price * (1 + vatPercentage / 100)).toFixed(2)
                                : (NetPaymentAoumt * (1 + vatPercentage / 100)).toFixed(2)
                            : type === PAYMENT_TYPES.LIVE
                              ? !promoCodeDiscount
                                ? ((liveDetails?.amount || 0) * (1 + vatPercentage / 100)).toFixed(2)
                                : ""
                              : type === PAYMENT_TYPES.LIVE_TIP
                                ? !promoCodeDiscount
                                  ? ((liveTipDetails?.amount || 0) * (1 + vatPercentage / 100)).toFixed(2)
                                  : ""
                                : ""}{" "}
                        €{" "}
                      </Typography.Text>
                    </Row>
                  </>
                )} */}
                <Row className="mt-20">
                  <Typography.Text className="fanPaymentLargeLabel">{t("promo-code")}</Typography.Text>
                </Row>
                <Row className="mt-7">
                  <InputComponent
                    className="authInput uppercaseInput"
                    placeholder={handleCheck(true) ? "" : "EX : AB123"}
                    value={handleCheck(true) ? t("free-subscription-title") : PromoCode}
                    onChange={(e) => !handleCheck(true) && setPromoCode(e.target.value)}
                    disabled={isLoadingSubInfo || handleCheck(true)}
                    suffix={
                      handleCheck(true) ? (
                        <img src={InfoGreyIcon} className="info-icon" alt="Info" onClick={() => setShowPaymentInfoModal(true)} />
                      ) : (
                        <Button onClick={PromoCodeApply} className="fanPaymentCodeBtnSuffix">
                          {t("apply-label")}
                        </Button>
                      )
                    }
                  />
                </Row>
              </div>
            </Row>
            {handleShowSavedCards() && (
              <Row className="SaveCardContainer">
                {allCards?.map((item: any, index: any) => {
                  return (
                    <SaveCards
                      key={index}
                      data={item}
                      totalData={allCards?.length}
                      selectedCard={selectedCard}
                      handleClick={() => handleSelectCard(item)}
                    />
                  );
                })}
              </Row>
            )}
            <div className="padding-inline-23">
              <Row className="apple-pay-button-row" style={{ marginTop: "16px" }}>
                <TheApplePayButton
                  paymentAmount={calculateApplePayAmount}
                  currentUser={currentUser}
                  title={() => getLabel(type)}
                  handlePayment={handlePaymentMethod}
                  type={type}
                />
              </Row>
            </div>
            <Row className={`fanPaymentMainContent ${!isApplePay && "mt-5"} `}>
              <Row className="w-full ">
                <Space className="w-full" direction="vertical">
                  <Typography.Text className="fanPaymentLargeLabel">{t("country")}</Typography.Text>
                  <CountryDropdownComponent currentValue={country} setCurrentValue={setCountry} countries={countries || []} />
                </Space>
              </Row>
              {payemntGateway === "shift4" && (
                <>
                  {selectedCard === null && (
                    <>
                      {" "}
                      <Row className="w-full">
                        <Typography.Text className="fanPaymentLargeLabel">{t("holder-name")}</Typography.Text>
                      </Row>
                      <Row className="w-full mt-5" gutter={8}>
                        <Col span={12}>
                          <Space className="w-full" direction="vertical">
                            <InputComponent
                              maxLength={19}
                              className="authInput"
                              onChange={(e) => setCardHolderName({ ...cardHolderName, firstname: e.target.value })}
                              value={cardHolderName?.firstname}
                              placeholder={t("first-name-label") || ""}
                              disabled={selectedCard !== null}
                            />
                          </Space>
                        </Col>
                        <Col span={12}>
                          <Space className="w-full" direction="vertical">
                            <InputComponent
                              maxLength={19}
                              className="authInput"
                              onChange={(e) => setCardHolderName({ ...cardHolderName, lastname: e.target.value })}
                              value={cardHolderName?.lastname}
                              placeholder={t("last-name-label") || ""}
                              disabled={selectedCard !== null}
                            />
                          </Space>
                        </Col>
                      </Row>
                      <Row className="w-full mt-20">
                        <Space className="w-full" direction="vertical">
                          <Typography.Text className="fanPaymentLargeLabel">{t("card-number")}</Typography.Text>
                          <InputComponent
                            maxLength={19}
                            className="authInput"
                            onChange={(e) => {
                              if (e.target.value.match(cardnumberReg)) {
                                setCardNumber(formatNumber(e.target.value));
                              }
                            }}
                            value={cardNumber}
                            placeholder="1234 1234 1234"
                            onKeyDown={(e) => setKey(e.key)}
                            disabled={selectedCard !== null}
                            inputMode="numeric"
                          />
                        </Space>
                      </Row>
                      <Row className="w-full mt-20 mb-20">
                        <Col span={12} className="custom-col">
                          <Space direction="vertical" style={{ width: "100%" }}>
                            <Typography.Text className="fanPaymentLargeLabel">{t("expiration-date")}</Typography.Text>
                            <InputComponent
                              className="authInput"
                              inputMode="numeric"
                              placeholder="MM/YY"
                              maxLength={5}
                              onChange={(e) => {
                                if (e.target.value.match(CardMonthYearReg)) {
                                  const [month, year] = e.target.value.split("/");
                                  const inputYear = parseInt(year, 10);
                                  const inputMonth = parseInt(month, 10);

                                  setMonthYear(e.target.value);
                                  if (inputYear) {
                                    if (inputYear >= expCurrentYear && inputMonth <= 12) {
                                      setMonthYear(e.target.value);
                                      setError("");
                                      setExpiredDateError(false);
                                    } else {
                                      setExpiredDateError(true);
                                      setError(t("enter-valid-expiry-month-and-year")!);
                                    }
                                  }
                                }
                              }}
                              value={MonthYear}
                              onKeyDown={(e) => setKey(e.key)}
                              disabled={selectedCard !== null}
                              inputError={expiredDateError}
                            />
                          </Space>
                        </Col>
                        <Col span={12} className="custom-col">
                          <Space direction="vertical" style={{ width: "100%" }}>
                            <Typography.Text className="fanPaymentLargeLabel">{t("cryptogram")}</Typography.Text>
                            <InputComponent
                              className="authInput"
                              inputMode="numeric"
                              placeholder="CVC"
                              onChange={(e) => {
                                if (e.target.value.match(cvvReg)) {
                                  setCvv(e.target.value);
                                }
                              }}
                              value={cvv}
                              maxLength={3}
                              disabled={selectedCard !== null}
                            />
                          </Space>
                        </Col>
                      </Row>
                    </>
                  )}

                  <Row className="">
                    <Checkbox className="paymentTermsCheckBox" checked={checkboxChecked} onChange={handleCheckboxChange}>
                      {t("payment-terms")}
                    </Checkbox>
                  </Row>
                  <Row className="mt-20 w-full justify-content-center">
                    <Typography.Text className="transaction-text">{t("transaction-appear-bank-statement-universal-media")}</Typography.Text>
                  </Row>

                  <Row className="mt-20 w-full justify-content-center">
                    <img src={InfoPaymentImg} width={200} alt="" />
                  </Row>
                  <Row className="mt-10 w-full justify-content-center">
                    <Typography.Text className="info-company-text">ITDW SRL</Typography.Text>
                  </Row>
                  <Row className="w-full justify-content-center">
                    <Typography.Text className="info-company-text">VAT: BE0789767565</Typography.Text>
                  </Row>
                  <Row className="w-full justify-content-center mb-60">
                    <Typography.Text className="info-company-text">6280, Gerpinnes, Belgium</Typography.Text>
                  </Row>
                  <Row className="fanSubscribeContinueButtonWrap stickyButtonWrapper">
                    <div className="w-button">
                      <AuthButtonComponent
                        onClick={() => {
                          subscribe(selectedCard ? selectedCard?.id : null);
                        }}
                        label={t("confirm")}
                        disabled={!buy}
                      />
                    </div>
                  </Row>
                </>
              )}
              {payemntGateway === "stripe" && (
                <StripeCheckoutForm
                  setLoading={setIsLoading}
                  checkboxChecked={checkboxChecked}
                  handleCheckboxChange={handleCheckboxChange}
                  loading={isLoading}
                  handlePayment={subscribe}
                  paymentAmount={calculateAmount}
                />
              )}
              {/* {paymentMethod === "bankCard" ? (
                <>
                  {" "} */}
              {/* </>
              ) : (
                ""
              )} */}

              {/* <Row className="fanSubscribeContinueButtonWrap mt-40">
                <Typography.Text className="fanPaymentSmallLabel">{t("fan-payment-end-text")}</Typography.Text>
              </Row> */}
            </Row>
          </Col>
          <FanPaymentPopUp paymentStatus={paymentStatus} setPaymentStatus={setpaymentStatus} username={user?.infos.username!} />
          {showPaymentInfoModal && <FreeSubscriptionPaymentInfoModal onClose={() => setShowPaymentInfoModal(false)} creatorName={user?.infos.name} />}
        </Layout.Content>
      </Layout>
    </Spin>
  );
};

export default FanPaymentPage;
